class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
  }

  connectedCallback() {
    this.startTimer();
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startTimer() {
    const timerElement = this.querySelector('[data-timer]');
    if (!timerElement) return;

    // Store initial server time offset
    const currentDate = timerElement.getAttribute('data-current-date');
    const serverTime = new Date(currentDate);
    const initialTime = Date.now();
    const timeOffset = serverTime.getTime() - initialTime;

    const updateTimer = () => {
      const endDate = timerElement.getAttribute('data-end-date');
      
      // Current time adjusted for server offset
      const now = new Date(Date.now() + timeOffset);
      const target = new Date(endDate);
      
      const diff = target.getTime() - now.getTime();
      
      if (diff <= 0) {
        timerElement.innerHTML = `
          <span class="timer-part">0 <small>days</small></span>
          <span class="timer-separator">:</span>
          <span class="timer-part">00 <small>hrs</small></span>
          <span class="timer-separator">:</span>
          <span class="timer-part">00 <small>min</small></span>
          <span class="timer-separator">:</span>
          <span class="timer-part">00 <small>sec</small></span>
        `;
        if (this.timer) {
          clearInterval(this.timer);
        }
        return;
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      const formatTime = (time) => time.toString().padStart(2, '0');

      const daysHTML = days > 0 ? `<span class="timer-part">${days} <small>day${days !== 1 ? 's' : ''}</small></span><span class="timer-separator">:</span>` : '';

      timerElement.innerHTML = `
        ${daysHTML}
        <span class="timer-part">${formatTime(hours)} <small>hrs</small></span>
        <span class="timer-separator">:</span>
        <span class="timer-part">${formatTime(minutes)} <small>min</small></span>
        <span class="timer-separator">:</span>
        <span class="timer-part">${formatTime(seconds)} <small>sec</small></span>
      `;
    };

    // Initial update
    updateTimer();
    
    // Update every second
    this.timer = setInterval(updateTimer, 1000);
  }
}

// Register the custom element
customElements.define('countdown-timer', CountdownTimer);